<template>
  <button type="button" class="relative flex items-center justify-center w-8 h-8 p-0 bg-transparent border-0 overflow-hidden" @click="$emit('click')">
    <TheNuxtIcon name="notification" icon-type="svg" class="text-2xl text-gray-200 leading-none"/>
    <span v-if="count > 0"
          class="absolute top-1 right-0 rounded-full bg-secondary-900 border-2 border-gray-900 box-content"
          style="width: 8px; height: 8px;"/>
  </button>
</template>

<script setup lang="ts">
defineProps<{ count: number }>()
defineEmits<{ click: [] }>()
</script>
